import { DispenserListItem } from '@/features/dispensers/services/schemas.ts';
import { modelColumnDefFactory } from '@/common/components/app-data-grid/utils/modelColumnDefFactory.ts';
import { GridColDef } from '@mui/x-data-grid/models';
import { t } from '@lingui/core/macro';
import { ActionsCell } from '@/features/dispensers/components/dispenser-list/subcomponents/actions-cell/ActionsCell.tsx';
import { GridConfig } from '@/common/components/app-data-grid/GridConfig.ts';

export const DISPENSER_GRID_CONFIG: GridConfig<DispenserListItem> = {
  sortableFields: ['sn', 'computerId', 'type'],
  filterableFields: ['sn', 'computerId', 'type'],
};

const modelColumnDef = modelColumnDefFactory<DispenserListItem>(DISPENSER_GRID_CONFIG);

export const getColumns = (): GridColDef<DispenserListItem>[] => [
  modelColumnDef('sn', { headerName: t`Serial Number`, flex: 1 }),
  modelColumnDef('pos', { headerName: t`Point of Sale`, flex: 1 }),
  modelColumnDef('country', { headerName: t`Country`, flex: 1 }),
  modelColumnDef('type', { headerName: t`Type`, flex: 0.75 }),
  modelColumnDef('computerId', { headerName: t`Current Collector`, flex: 0.75 }),
  {
    field: 'actions',
    type: 'actions',
    renderCell: (params) => <ActionsCell {...params} />,
    width: 50,
    resizable: false,
  },
];
